import * as React from "react";

import { cn } from "./utils";

function Input({
  className,
  type,
  value,
  defaultValue,
  ...props
}: React.ComponentProps<"input">) {
  // Determine if input has value (for background color)
  const hasValue =
    (value !== undefined && value !== null && String(value).trim() !== "") ||
    (value === undefined &&
      defaultValue !== undefined &&
      defaultValue !== null &&
      String(defaultValue).trim() !== "");

  return (
    <input
      {...props}
      data-slot="input"
      type={type}
      value={value}
      defaultValue={defaultValue}
      className={cn(
        // Default: gray background when empty, white when has value. Active (focus): white background.
        "file:text-foreground placeholder:text-muted-foreground selection:bg-primary selection:text-primary-foreground dark:bg-input/30 border-input flex h-9 w-full min-w-0 rounded-md border px-3 py-1 text-base transition-[color,box-shadow,background-color] outline-none select-text file:inline-flex file:h-7 file:border-0 file:bg-transparent file:text-sm file:font-medium disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-50 md:text-sm",
        // Background: gray when empty, white when has value
        hasValue ? "bg-white" : "bg-input-background",
        // Focus always white
        "focus:bg-white focus-visible:bg-white",
        "focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px]",
        "aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive",
        className,
      )}
    />
  );
}

export { Input };
